import type { ReactElement } from "react";

import { FormSummary } from "../../forms/fields.js";
import { useApiForm } from "../../forms/use-api-form.js";

import { adminCenterApi } from "./urls.js";

/** 最後の確認（重要な操作は最後にダイアログで確かめる。docs/01 §7）。 */
export const resetTwoFactorDialog = (email: string): string =>
    `${email} の二段階認証を解除します。次のログインで、認証アプリの登録し直しになります。`
    + "ご本人であることを確かめましたか？ よろしいですか？";

/**
 * 二段階認証の解除（Implem.Portal.Backend の docs/features/34 §2）。ロックの解除の画面で調べた人の結果に置く。
 * <b>認証アプリを登録している人にだけ出す</b>（<c>twoFactorEnrolled</c>。サーバが決める）。
 *
 * 認証アプリを失くし、ご登録のメールも受け取れない人のための運営の手段。
 * メールを受け取れる人は、メールの確認コードでログインしてアカウント設定から自分で解除できる。
 */
export function TwoFactorResetSection({ email }: { readonly email: string }): ReactElement {
    const form = useApiForm(adminCenterApi.resetTwoFactor, undefined, resetTwoFactorDialog(email));

    return (
        <div className="mt-6 border-t border-slate-200 pt-6" data-two-factor-reset="">
            <h3 className="mb-2 text-sm font-semibold">二段階認証</h3>
            <p className="mb-4 text-sm text-slate-500">
                認証アプリを登録しています。認証アプリを失くし、ご登録のメールも受け取れない方だけ解除してください
                （メールを受け取れる方は、ログインの途中で「メールで確認コードを受け取る」を選び、アカウント設定からご自身で解除できます）。
                解除すると、次のログインで認証アプリの登録し直しになります。
            </p>
            <form method="post" onSubmit={form.onSubmit}>
                <FormSummary messages={form.summary} />
                <input type="hidden" name="email" value={email} />
                <button type="submit" className="btn-danger-quiet btn-sm" disabled={form.busy}>二段階認証を解除する</button>
            </form>
        </div>
    );
}
